<template>
  <el-dialog :visible.sync="dialogVisible"
             :show-close="false"
             :destroy-on-close="true"
             :modal-append-to-body="false"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             width="800px" class="TheOrderEdit">
    <div slot="title" class="dialog-header">
      <div class="header-title">
        <span class="title">{{ $lang('退换货') }}</span><i></i>
        <span class="status">{{ statusTitle }}</span>
      </div>
      <img class="dialog-close" src="@/assets/images/close.png" alt="关闭" @click="onClose()">
    </div>
    <div class="dialog-main">
      <div class="d-flex flex-row">
        <the-cell :label="$lang('订单号')" :value="rowData.omsOrderThirdExtVO.orderId"/>
        <the-cell :label="$lang('运单编号')" :value="rowData.waybillId || '--'" style="margin-left: 16px;"/>
        <the-cell :label="$lang('下单时间')" :value="rowData.inputTime" style="margin-left: 16px;"/>
      </div>
      <div class="sender-info d-flex flex-row flex-nowrap">
        <div class="sender">{{ $lang('寄方') }}</div>
        <div class="info">
          <div style="margin-bottom: 8px;">
            <span class="name">{{ rowData.senderName }}</span>
            <span class="phone">{{ rowData.senderMobilePhone }}</span>
          </div>
          <p class="address">{{ rowData.senderProvinceName }}{{
              rowData.senderCityName
            }}{{countryId === 1 && rowData.senderAreaName ? rowData.senderAreaName : ''}}{{ rowData.senderStreet !== undefined && rowData.senderStreet !== null ? rowData.senderStreet : '' }}{{ rowData.senderDetailedAddress }}
            {{countryId === 1 && rowData.senderShortAddress ? rowData.senderShortAddress : ''}}
            {{countryId === 1 && rowData.senderReferenceNumber ? rowData.senderReferenceNumber : ''}}
            {{countryId === 1 && rowData.senderBuildingNumber ? rowData.senderBuildingNumbe : ''}}
          </p>
        </div>
      </div>
      <el-form class="form-edit"
               ref="ruleForm"
               :rules="rules"
               :inline="true"
               :model="rowData"
               label-position="left"
               label-suffix=":"
               label-width="100%">
        <div>
          <h3>{{ $lang('收件人信息') }}</h3>
          <div class="group-container">
            <el-form-item :label="$lang('姓名')" prop="receiverName">
              <el-autocomplete :maxlength="30"
                               valueKey="name"
                               v-model="rowData.receiverName"
                               @select="onChangeReceiverName"
                               :fetch-suggestions="remoteReceiverName"
                               :placeholder="$lang('请输入收件人姓名')">
                <template slot="suffix">
                  <i class="iconfont icondizhibao pointer" @click="openAddress(2)"></i>
                </template>
              </el-autocomplete>
            </el-form-item>

            <el-form-item :label="$lang('手机')" prop="receiverMobilePhone">
              <BasePhoneInput v-model="rowData.receiverMobilePhone" :maxlength="16"/>
            </el-form-item>

            <el-form-item :label="$lang('备用号码')" prop="receiverTelphone">
              <BasePhoneInput v-model="rowData.receiverTelphone" :maxlength="16"/>
            </el-form-item>

            <el-form-item :label="$lang('公司')" prop="receiverCompany">
              <el-input v-model="rowData.receiverCompany" :placeholder="$lang('请输入公司')" :minlength="1" :maxlength="20"/>
            </el-form-item>

            <el-form-item :label="$lang('邮编')">
              <el-input v-model.trim="rowData.receiverPostalCode" :minlength="1" :maxlength="20"/>
            </el-form-item>

            <el-form-item :label="$lang('邮箱')">
              <el-input v-model.trim="rowData.receiverEmail" :minlength="1" :maxlength="30"/>
            </el-form-item>

            <el-form-item :label="receiverProvinceName" prop="receiverProvinceName">
              <el-select v-model="rowData.receiverProvinceName" filterable @change="onProvinceChange($event)">
                <el-option v-for="item in provinceArray"
                           :key="item.id"
                           :label="item.nativeName"
                           :value="item.id"/>
              </el-select>
            </el-form-item>

            <el-form-item :label="receiverCityName" prop="receiverCityName">
              <el-select v-model="rowData.receiverCityName" filterable @change="onCityChange($event)">
                <el-option v-for="item in cityList2"
                           :key="item.id"
                           :label="item.nativeName"
                           :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item :label="$lang('收件区域')" prop="receiverAreaName" v-if="countryId === 1">
              <el-select v-model="rowData.receiverAreaName" filterable @change="onAreaChange($event)">
                <el-option v-for="item in areaList"
                  :key="item.id"
                  :label="item.nativeName"
                  :value="item.id"/>
              </el-select>
            </el-form-item>

            <el-form-item :label="$lang('收件街道')" prop="receiverStreet">
              <el-input v-model="rowData.receiverStreet" :placeholder="$lang('请输入收件街道')" :minlength="1" :maxlength="20"/>
            </el-form-item>

            <el-form-item :label="$lang('详细地址')" prop="receiverDetailedAddress" class="form-address">
              <el-input v-model="rowData.receiverDetailedAddress" :placeholder="$lang('请填写收件人所在街道以及详细地址')" :minlength="1" :maxlength="200" style="margin-right: 15px;"/>
            </el-form-item>
            <el-form-item v-if="countryId === 1" :label="$lang('收件短地址')" prop="receiverShortAddress">
              <template slot="label"><span :title="$lang('收件短地址')">{{ $lang('收件短地址') }}</span></template>
              <el-input v-model="rowData.receiverShortAddress" :placeholder="$lang('请输入收件短地址')" :minlength="1" :maxlength="8" @blur="judgeShortAddress(rowData)" />
            </el-form-item>
            <el-form-item v-if="countryId === 1" :label="$lang('收件辅助编号')" prop="receiverReferenceNumber">
              <template slot="label"><span :title="$lang('收件辅助编号')">{{ $lang('收件辅助编号') }}</span></template>
              <el-input v-model="rowData.receiverReferenceNumber" :placeholder="$lang('请输入收件辅助编号')" :minlength="1" :maxlength="20"/>
            </el-form-item>
            <el-form-item v-if="countryId === 1" :label="$lang('收件建筑物编号')" prop="receiverBuildingNumber">
              <template slot="label"><span :title="$lang('收件建筑物编号')">{{ $lang('收件建筑物编号') }}</span></template>
              <el-input v-model="rowData.receiverBuildingNumber" :placeholder="$lang('请输入收件建筑物编号')" :minlength="1" :maxlength="20"/>
            </el-form-item>
          </div>
        </div>
        <div>
          <h3>{{ $lang('货物信息') }}</h3>
          <div class="group-container">
            <el-form-item :label="$lang('件数')">
              <el-input :value="rowData.packageNumber" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('物品类型')">
              <el-input :value="rowData.goodsTypeName" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('物品名称')">
              <el-input :value="rowData.goodsName" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('物品重量(kg)')">
              <el-input :value="rowData.packageTotalWeight" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('结算方式')">
              <el-input :value="rowData.payment" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('支付方式')">
              <el-input :value="rowData.paidMode" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('退换货类型')">
              <el-input :value="rowData.returnType===1?'reverse':$lang('退换货')" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('参考运费')">
              <el-input :value="rowData.standardValue" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('客户订单号')">
              <el-input :value="rowData.customerOrderId" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('平台')">
              <el-input :value="rowData.platformName" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('客户账号')">
              <el-input :value="rowData.customerAccount" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item>
              <div slot="label"></div>
              <el-checkbox value="codFlag" disabled>{{ $lang('是否代收货款') }}</el-checkbox>
            </el-form-item>

            <el-form-item :label="$lang('代收货款币别')">
              <el-input :value="rowData.codCurrencyTypeName" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('代收货款金额')">
              <el-input :value="rowData.codMoney" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('代收货款手续费')">
              <el-input v-model="rowData.codFee" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item style="width: auto;margin-top: 20px;">
              <el-switch :value="rowData.isUnpackEnabled === 1" :active-text="$lang('是否允许客户开箱验视')" disabled/>
            </el-form-item>

            <el-form-item :label="$lang('是否购买赔偿上限服务')">
              <el-input :value="rowData.insured===1?$lang('是'):$lang('否')" placeholder="--" disabled/>
            </el-form-item>

            <el-form-item :label="$lang('货物价值')" v-show="rowData.insured === 1">
              <el-input :value="rowData.declaredValue" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('赔偿上限服务费')" v-show="rowData.insured===1">
              <el-input :value="rowData.insuredValue" placeholder="--" readonly/>
            </el-form-item>

            <el-form-item :label="$lang('商品图片')" v-if="type === 1" style="width: 100%">
              <the-upload-image :upload-url="COM_HTTP.fetchUploadImage"
                                :uploadData="uploadData"
                                :list="imageList"
                                :limit="10"
                                :file-type-list="['png', 'jpg', 'jpeg']"
                                @uploadSuccess="uploadSuccess"
                                @uploadRemove="uploadRemove"/>
            </el-form-item>

            <el-form-item :label="$lang('商品描述')" required v-if="type === 1" style="width: 100%">
              <el-input v-model="productDescription" type="textarea" :rows="5" show-word-limit :maxlength="1000" resize="none" :placeholder="$lang('请输入')"/>
            </el-form-item>

            <el-form-item :label="$lang('备注')" prop="remarks" v-if="type === 2" style="width: 100%">
              <el-input v-model="rowData.remarks" type="textarea" :rows="5" show-word-limit :maxlength="200" resize="none" :placeholder="$lang('请输入')"/>
            </el-form-item>
          </div>
          <div style="padding: 30px 0; text-align: center; position: sticky; bottom: 0; background-color: #FFFFFF; z-index: 9;">
            <el-button type="primary" :loading="isSubmitLoading" @click="updateOrder('ruleForm')" class="h48">{{ $lang('提交') }}</el-button>
          </div>
        </div>
      </el-form>
    </div>

    <address-book v-model="addrBook" :selectType="selectType" @single-row-select="singleRowSelect" ref="address"/>
  </el-dialog>
</template>

<script>
import TheCell from './TheCell'
import TheUploadImage from '@/views/return-exchange/components/TheUploadImage'
import { checkAddressFormat, isNull, phoneAndMobile, RULES } from '@/utils/rules'
import { mapActions, mapGetters } from 'vuex'
import {
  fetchOSS,
  fetchUpdateOrderInfo,
  fetchUploadImage,
  getList, judgeShortAddress,
  reqAddressList
} from '@/api/module/customer'
import { RESPONSE_SUCCESS } from '@/constants'
import { GET_AREA, GET_AREANEW } from '@/api/base/public'
import AddressBook from '@/views/place-order/single-order/AddressBook'

export default {
  name: 'TheReturnExchangeEdit',
  components: { AddressBook, TheUploadImage, TheCell },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    type: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      COM_HTTP: { fetchUploadImage },
      statusTitle: '',
      rules: {
        receiverName: [RULES.required, { validator: isNull }],
        receiverMobilePhone: [RULES.required, { validator: phoneAndMobile }],
        receiverTelphone: [{ validator: phoneAndMobile }],
        receiverProvinceName: [RULES.requiredSelect],
        receiverCityName: [RULES.requiredSelect],
        receiverDetailedAddress: [RULES.required, { validator: checkAddressFormat }],
        receiverShortAddress: [RULES.codeNumber],
        buildingNumber: [RULES.twenty],
        referenceNumber: [RULES.twenty],
      },
      senderProvinceName: this.$lang('省份'),
      receiverProvinceName: this.$lang('省份'),
      receiverCityName: this.$lang('收件城市'),
      codCurrencyType: [],
      receiptFreight: 0,
      codNumber: 3000, // 代收货款最大值
      initData: {
        url: '/oauth/sysRoleResource/getAppResources',
        type: 'app',
        leftText: this.$lang('未选权限'),
        rightText: this.$lang('已选权限'),
        rightOptText: this.$lang('全部权限'),
        exculdeIdsParam: 'resourceIds',
      },
      receiverAddressData: {
        formProps: {
          provinceIdProp: 'receiverProvinceId',
          provinceNameProp: 'receiverProvinceName',
          cityIdProp: 'receiverCityId',
          cityNameProp: 'receiverCityName',
        },
        defaultData: {},
      },
      insuredDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      signReceiptDic: [{ code: 0, label: this.$lang('否'), name: this.$lang('否') }, { code: 1, label: this.$lang('是'), name: this.$lang('是') }],
      paidOption: false,
      cityList: [],
      cityList2: [],
      areaList: [],
      provinceArray: [],
      codIsInput: true,
      codFlag: false, // 是否代收货款
      senderExpressTypeData: [], // 产品类型
      receiverExpressTypeData: [],
      uploadData: {
        projectName: 'yl-jmssa-vip',
        moduleName: 'vip'
      },
      // 商品图片
      imageList: [],
      productDescription: '',
      isSubmitLoading: false, // 提交数据加载
      addrBook: false,
      selectType: 1,
    }
  },
  created() {
    // 获取酋长国数据
    this.getProList()
    // 获取基础数据
    this.getBaseDataList()
    // 获取币别
    this.getCurrencyTypeList()
    // 是否购买赔偿上限服务是:1, 否:0
    if (this.rowData.insured === 1) {
      this.rules.declaredValue = [RULES.required, RULES.declaredValue]
    }
  },
  async activated() {
    if (this.rowData.omsOrderThirdExtVO.productSkuImageUrl) {
      this.imageList = []
      const { omsOrderThirdExtVO } = this.rowData
      const tempArr = []
      const paths = omsOrderThirdExtVO.productSkuImageUrl.split(',')
      for (const item of paths) {
        const { code, data, msg } = await fetchOSS([item])
        if (code === RESPONSE_SUCCESS) {
          tempArr.push({
            path: item,
            url: data[0],
          })
        } else {
          this.$message.error(msg)
        }
      }
      this.imageList = tempArr
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'user'
    }),
    // 城市编号
    countryCode() {
      return this.$store.state.base.user.countryCode || ''
    },
    countryId() {
      return this.$store.state.base.user.countryId || ''
    }
  },
  watch: {
    countryCode: {
      handler(val) {
        if (val === 'UAE') {
          // 阿联酋的用户行政区域要变
          this.senderProvinceName = this.$lang('寄件酋长国')
          this.receiverProvinceName = this.$lang('收件酋长国')
          this.receiverCityName = this.$lang('收件区域')
        }
      },
      immediate: true,
    },
    rowData: {
      deep: true,
      async handler(newVal, oldVal) {
        // 订单：(100, "未调派; 101, "已调派网点"; 102, "已调派业务员"; 103, "已取件";  104, "已取消";105, "取件失败")
        switch (Number(this.rowData.orderStatusCode)) {
          case 100:
            this.statusTitle = this.$lang('待取件')
            break
          case 101:
            this.statusTitle = this.$lang('待取件')
            break
          case 102:
            this.statusTitle = this.$lang('待取件')
            break
          case 103:
            this.statusTitle = this.$lang('已取件')
            break
          case 104:
            this.statusTitle = this.$lang('已取消')
            break
        }
      }
    },
    async dialogVisible(val) {
      if (val && this.type === 1) {
        this.productDescription = this.rowData.omsOrderThirdExtVO.productDescription
        if (this.rowData.omsOrderThirdExtVO.productSkuImageUrl) {
          this.imageList = []
          const { omsOrderThirdExtVO } = this.rowData
          const tempArr = []
          const paths = omsOrderThirdExtVO.productSkuImageUrl.split(',')
          for (const item of paths) {
            const { code, data, msg } = await fetchOSS([item])
            if (code === RESPONSE_SUCCESS) {
              tempArr.push({
                path: item,
                url: data[0],
              })
            } else {
              this.$message.error(msg)
            }
          }
          this.imageList = tempArr
        }
      }
    },
  },
  methods: {
    async judgeShortAddress(rowData) {
      if (!rowData?.receiverShortAddress) {
        rowData.receiverShortAddress = ''
        return
      }
      const regex = /^[A-Za-z]{4}\d{4}$/
      if (!regex.test(rowData.receiverShortAddress)) {
        rowData.receiverShortAddress = ''
        this.$message.error(this.$lang('不符合短地址规则'))
        return
      }
      try {
        const { code, data } = await judgeShortAddress({
          shortAddress: rowData.receiverShortAddress
        })
        if (code !== RESPONSE_SUCCESS || data !== true) {
          rowData.receiverShortAddress = ''
          this.$message.error(this.$lang('未查询到短地址信息,请输入正确的短地址'))
        }
      } catch (error) {
        rowData.receiverShortAddress = ''
      }
    },
    onClose() {
      this.$emit('update:dialogVisible', false)
    },
    ...mapActions(['UPDATE_PRINT_STOCK']),
    /**
     * 获取基础数据
     * @returns {Promise<void>}
     */
    async getBaseDataList() {
      const { data, code, msg } = await getList()
      if (code === RESPONSE_SUCCESS) {
        this.prodectData = data['appProductTypeVOList']
        console.log('获取基础数据', this.prodectData)
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 获取酋长国数据
     * @returns {Promise<void>}
     */
    async getProList() {
      const { data, code, msg } = await GET_AREA({ current: 1, size: 9999, type: 2 })
      if (code === RESPONSE_SUCCESS) {
        this.provinceArray = data
        console.log(this.provinceArray)
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 获取地址薄信息
     * @param params
     * @param queryString
     * @param cb
     * @returns {Promise<void>}
     */
    async getAddressList(params, queryString, cb) {
      const { data, msg, code } = await reqAddressList(params)
      if (code === RESPONSE_SUCCESS) {
        this.loading = false
        const diseaseList = data.records
        const results = queryString ? diseaseList.filter(item => item['name'].toLowerCase().indexOf(queryString.toLowerCase()) !== -1) : diseaseList
        // 调用 callback 返回建议列表的数据
        cb(results)
      } else {
        cb([])
        this.$message.error(this.$lang(msg))
        this.loading = false
      }
    },
    /**
     * 地址簿选择弹窗功能
     * @param data
     * @param type
     */
    singleRowSelect(data, type) {
      if (!data.cityId) {
        return
      }
      const { name, mobile, detailedAddress, companyName, reserveMobile } = data
      if (type === 1) { // 1寄件2取件
        this.rowData.senderName = name // 寄件人姓名,
        this.rowData.senderMobilePhone = this.filterPhone(mobile) // 寄件人手机号
        this.rowData.senderDetailedAddress = detailedAddress // 寄件详细地址
        this.rowData.senderCompany = companyName
        this.setProvince(data, type)
      } else if (type === 2) {
        this.rowData.receiverName = name // 收件人姓名,
        this.rowData.receiverMobilePhone = this.filterPhone(mobile) // 收件人手机号
        this.rowData.receiverTelphone = this.filterPhone(reserveMobile) // 收件人备用手机号
        this.rowData.receiverDetailedAddress = detailedAddress // 收件详细地址
        this.rowData.receiverCompany = companyName
        this.setProvince(data, type)
      }
    },
    /**
     * 收件人姓名模糊搜索
     * @param queryString
     * @param cb
     * @returns {Promise<void>}
     */
    async remoteReceiverName(queryString, cb) {
      this.loading = true
      const params = {
        current: 1,
        size: 100,
        type: 2,
        keyword: queryString,
      }
      await this.getAddressList(params, queryString, cb)
    },
    /**
     * 打开地址薄
     * @param selectType
     */
    openAddress(selectType) {
      this.addrBook = true
      this.selectType = selectType
      const data = selectType === 1 ? this.curentSend : this.curentReceiver
      this.$refs.address.updateBtnStauts(data)
      this.$refs.address.initData()
    },
    /**
     * 监听收件人姓名或者电话改变
     * @param item
     */
    onChangeReceiverName(item) {
      this.rowData.receiverName = item.name
      this.rowData.receiverMobilePhone = this.filterPhone(item.mobile)
      this.rowData.receiverTelphone = this.filterPhone(item.reserveMobile)
      this.rowData.receiverCompany = item.companyName
      this.rowData.receiverDetailedAddress = item.detailedAddress
      this.setProvince(item, 2)
    },
    /**
     * 收货的城市重新赋值
     * onChangeSenderName/onChangeReceiverName方法使用
     * @param row
     * @param type
     */
    setProvince(row, type) {
      const { cityId, cityName, provinceId, provinceName, areaName, areaId, street } = row
      if (type === 1) {
        this.rowData.senderProvinceId = provinceId
        this.rowData.senderProvinceName = provinceName
        this.rowData.senderCityId = cityId
        this.rowData.senderCityName = cityName
        this.rowData.senderStreet = street
        if (this.countryId === 1) {
          this.rowData.senderAreaName = areaName
          this.rowData.senderAreaId = areaId
        }
        this.getCityInfo(provinceId, 1)
      } else {
        this.rowData.receiverProvinceId = provinceId
        this.rowData.receiverProvinceName = provinceName
        this.rowData.receiverCityId = cityId
        this.rowData.receiverCityName = cityName
        this.rowData.receiverStreet = street
        if (this.countryId === 1) {
          this.rowData.receiverAreaName = areaName
          this.rowData.receiverAreaId = areaId
        }
        this.getCityInfo(provinceId)
      }
      this.getAreaInfo(cityId)
    },
    /**
     * 监听收货的省份切换获取城市列表
     * @param pid 省份id
     * @param type 寄件人
     */
    async onProvinceChange(pid, type) {
      const { data, code, msg } = await GET_AREA({ current: 1, size: 9999, type: 3, parentId: pid })
      if (code === RESPONSE_SUCCESS) {
        this.cityList2 = data
        this.rowData.receiverProvinceId = pid
        this.rowData.receiverCityId = data[0].id
        this.rowData.receiverCityName = data[0].nativeName
        if (this.countryId === 1) {
          this.getAreaList(data[0].id)
        }
        let obj = {}
        obj = this.provinceArray.find((item) => {
          return item.id === pid
        })
        this.rowData.receiverProvinceName = obj.nativeName
        this.receiverExpressTypeData = data[0].products || []
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 监听收货的城市切换
     * @param value
     */
    onCityChange(value) {
      this.rowData.receiverCityId = value
      const obj = this.cityList2.find((item) => {
        return item.id === value
      })
      this.rowData.receiverCityName = obj.nativeName
      this.receiverExpressTypeData = obj.products || []
      if (this.countryId === 1) {
        this.getAreaList(value)
      }
    },
    onAreaChange(value) {
      this.rowData.receiverAreaId = value
      const obj = this.areaList.find((item) => {
        return item.id === value
      })
      this.rowData.receiverAreaName = obj.nativeName
    },
    /**
     * 查询城市数据
     * @param provinceId
     * @param flagType
     * @returns {Promise<void>}
     */
    async getCityInfo(provinceId, flagType) {
      const { data, code, msg } = await GET_AREA({ current: 1, size: 9999, type: 3, parentId: provinceId })
      if (code === RESPONSE_SUCCESS) {
        this.cityList2 = data
        const item = data.find(({ id }) => id === this.rowData.receiverCityId)
        if (item) this.receiverExpressTypeData = item.products || []
      } else {
        this.$message.error(msg)
      }
    },
    async getAreaInfo (parentId) {
      const { data, code, msg } = await GET_AREANEW({ current: 1, size: 9999, type: 4, parentId })
      if (code === RESPONSE_SUCCESS) {
        this.areaList = data
      } else {
        this.$message.error(msg)
      }
    },
    async getAreaList(parentId) {
      const { data, code, msg } = await GET_AREANEW({ current: 1, size: 9999, type: 4, parentId })
      if (code === RESPONSE_SUCCESS) {
        this.areaList = data
        this.rowData.receiverAreaName = data[0].nativeName || ''
        this.rowData.receiverAreaId = data[0].id || ''
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * 过滤手机号
     * @param val
     * @returns {string|*}
     */
    filterPhone(val) {
      if (!val) return ''
      if (val.includes('+86') || val.includes('+966')) return val
      if (val.length === 11) return `+86-${val}`
      if (val.length === 9) return `+966-${val}`
      return val
    },
    /**
     * 上传
     * @param res
     * @param file
     * @param fileList
     */
    async uploadSuccess({ res, file, fileList }) {
      console.log('res', res)
      console.log('file', file)
      console.log('fileList', fileList)
      console.log('this.imageList', this.imageList)
      this.imageList.push(res)
      const paths = this.imageList.map(item => item.path)
      this.rowData.omsOrderThirdExtVO.productSkuImageUrl = paths.toString()
    },
    /**
     * 图片删除
     */
    uploadRemove(index, fileList) {
      this.imageList = fileList.filter((item, i) => i !== index)
    },
    /**
     * 数据提交
     * @returns {Promise<void>}
     */
    async updateOrder(formName) {
      this.isSubmitLoading = true

      const { omsOrderThirdExtVO } = this.rowData
      // 退货
      if (this.type === 1) {
        this.rowData.extInfo = {
          originalWaybillId: omsOrderThirdExtVO.originalWaybillId,
          returnType: omsOrderThirdExtVO.returnType,
          productSkuImageUrl: omsOrderThirdExtVO.productSkuImageUrl,
          productDescription: this.productDescription
        }
      }
      // 换货
      if (this.type === 2) {
        this.rowData.extInfo = {
          originalWaybillId: omsOrderThirdExtVO.originalWaybillId,
          returnType: omsOrderThirdExtVO.returnType,
        }
      }

      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            const { code, data, msg } = await fetchUpdateOrderInfo(this.rowData)
            if (code === RESPONSE_SUCCESS) {
              this.getOrderId = data.id
              this.$message({
                message: this.$lang('订单已修改'),
                type: 'success',
              })
              this.onClose()
            } else {
              this.$message.error(msg)
            }
            this.isSubmitLoading = false
          } catch (err) {
            this.isSubmitLoading = false
            this.$message.error(err)
          }
        } else {
          this.isSubmitLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.TheOrderEdit {

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .title {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFangSC;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
        font-weight: 600;
      }

      i {
        display: inline-block;
        border-radius: 50%;
        overflow: hidden;
        width: 8px;
        height: 8px;
        background: #fa8b14;
        margin-left: 16px;
        margin-right: 8px;
      }

      .status {
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 12px;
      }
    }

    .dialog-close {
      width: 16px;
      height: 16px;
      display: inline-block;
      cursor: pointer;
    }
  }

  .dialog-main {

    .sender-info {
      padding: 16px 0;

      .sender {
        width: 48px;
        height: 48px;
        background: #e60012;
        display: inline-block;
        border-radius: 50%;
        overflow: hidden;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: #fff;
        line-height: 48px;
        text-align: center;
      }

      .info {
        margin-left: 24px;
        flex: 1;
        -webkit-box-flex: 1;
        -ms-flex: 1;

        .name {
          max-width: 180px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFangSC;
          color: #333333;
          font-weight: 600;
        }

        .phone, address {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFangSC;
          font-weight: 400;
          color: #333333;
          margin-left: 24px;
        }

        .phone {
          color: #333333;
          margin-left: 24px;
        }

        .address {
          color: #666666;
        }
      }
    }
  }
}

::v-deep {
  .el-form-item {
    width: 200px;

    .el-form-item__content {
      width: 100% !important;
    }
  }

  .el-dialog {
    margin-top: 5vh !important;

    .el-dialog__body {
      height: 80vh;
      overflow: auto;
      padding: 20px 20px 0;
    }
  }
}

.form-edit {
  .group-container {
    background-color: #f7f7f9;
    padding: 20px 20px 0;
    border-radius: 8px;
  }
}
</style>
